import React, { useState } from 'react'
import { FormControl, MenuItem, TextField, InputAdornment } from '@mui/material'
import View from '../../atoms/view'
import theme from '../../../theme'

const textStyle = {
  fontFamily: 'Inter',
  fontWeight: 500,
  color: '#1a1a1a'
}

export const DropdownCustomValue = ({ 
  noBorder, 
  addOptionNone, 
  options, 
  placeholder, 
  value, 
  onChange, 
  isRequired, 
  title, 
  disabled, 
  size,
  error,
  helperText
}) => {
  
  const [isCustomMode, setIsCustomMode] = useState(() => {
    if (!value) return false
    const isValueInOptions = options?.some(option => (option.value ?? option.id ?? option.name) === value)
    return !isValueInOptions
  })

  const handleDropdownChange = (e) => {
    const selectedVal = e.target.value
    if (selectedVal === '__CUSTOM_TRIGGER__') {
      setIsCustomMode(true)
      onChange('') 
    } else {
      onChange(selectedVal)
    }
  }

  const handleRevertToDropdown = () => {
    setIsCustomMode(false)
    onChange('') 
  }

  return (
    <View>
      <View style={{ display: 'flex', flexDirection: 'row', gap: 5, marginBottom: 4 }}>
        {isRequired ? <View style={{ color: theme.colors.error }}>*</View> : null}
        <Title>{title}</Title>
      </View>
      
      {isCustomMode ? (
        <FormControl fullWidth size={size ?? 'small'}>
          <TextField
            size={size ?? 'small'}
            disabled={disabled}
            placeholder="Type custom value..."
            variant={noBorder ? 'standard' : 'outlined'}
            value={value ?? ''}
            onChange={(e) => onChange(e.target.value)}
            error={error}
            helperText={helperText}
            sx={{ input: { color: '#1a1a1a' } }}
            
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <span
                      onClick={handleRevertToDropdown}
                      style={{ 
                        cursor: 'pointer', 
                        fontSize: '12px', 
                        color: '#606060', 
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        padding: '4px'
                      }}
                    >
                      Cancel
                    </span>
                  </InputAdornment>
                )
              }
            }}
          />
        </FormControl>
      ) : (
        <FormControl fullWidth size={size ?? 'small'}>
          <TextField
            select
            size={size ?? 'small'}
            disabled={disabled}
            label={value ? '' : placeholder}
            id="demo-simple-select"
            variant={noBorder ? 'standard' : 'outlined'}
            value={value ?? ''}
            onChange={handleDropdownChange}
            
            sx={{ '& .MuiSelect-select': { color: '#1a1a1a' } }}
          >
            {addOptionNone ? <MenuItem style={textStyle} selected={false} value=""><em>{'None'}</em></MenuItem> : null}
            
            {options?.map((option) => (
              <MenuItem 
                onClick={option.onSelect} 
                style={textStyle} 
                key={option.id ?? option.name} 
                value={option.value ?? (option.id ?? option.name)}
              >
                <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', color: option.color ?? '#1a1a1a' }}>
                  {option.name}
                  {option.icon ? option.icon : null}
                </View>
              </MenuItem>
            ))}

            <MenuItem value="__CUSTOM_TRIGGER__" style={{ ...textStyle, fontWeight: 600, color: '#1744E2' }}>
              + Enter custom value...
            </MenuItem>
            
          </TextField>
        </FormControl>
      )}
    </View>
  )
}

export const Title = ({ children }) => {
  return (
    <View style={{
      color: '#606060',
      fontFamily: 'Inter',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 'normal',
      letterSpacing: '0.24px',
      textTransform: 'uppercase'
    }}>
      {children}
    </View>
  )
}